import { render, staticRenderFns } from "./VTattendanceAction.vue?vue&type=template&id=720cf725&"
import script from "./VTattendanceAction.vue?vue&type=script&lang=js&"
export * from "./VTattendanceAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports